import confetti from "canvas-confetti";

export function launchConfetti() {
  confetti({ angle: 60, spread: 55, origin: { x: 0 }, zIndex: 99999999999 });
  confetti({ angle: 120, spread: 55, origin: { x: 1 }, zIndex: 99999999999 });
}
